import { ReactNode, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { Button, Colors, Icon, Text } from '@mercator-gcp/grout';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'components/elements/Link';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { SUPPORT_EMAIL } from 'utils/constants';
import { buildProjectMapURLWithParams } from 'utils/navigation';

const containerStyle = {
  display: 'table',
  position: 'absolute',
  height: '100%',
  width: '100%',
};

const mainErrorStyle = {
  display: 'table-cell',
  verticalAlign: 'middle',
  paddingLeft: 'padding_16',
  paddingRight: 'padding_16',
};

const inner = {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '540px',
  alignItems: 'center',
  paddingTop: 'padding_48',
  paddingBottom: 'padding_64',
};

const headerStyle = {
  marginTop: 'padding_32',
  marginBottom: 'padding_16',
  textAlign: 'center',
};

const subHeaderStyle = {
  marginBottom: 'padding_16',
  textAlign: 'center',
};

const descriptionStyle = { marginBottom: 'padding_16', textAlign: 'center' };

const contactInfoStyle = {
  textAlign: 'center',
};

const backButtonStyle = { marginTop: 'padding_32' };

type TErrorProps = {
  errorImage: ReactNode;
  title: string;
  subtitle?: string;
  description: string;
};

const PROJECT_PAGE_PATH = '/projects';

const ErrorCover = ({ errorImage, title, subtitle, description }: TErrorProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else if (location.pathname === PROJECT_PAGE_PATH) {
      window.location.reload();
    } else {
      navigate(buildProjectMapURLWithParams({}));
    }
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={mainErrorStyle}>
        <FlexColumn sx={inner}>
          <Box>{errorImage}</Box>
          <Text.H1 sx={headerStyle}>{title}</Text.H1>
          {subtitle && <Text.H3 sx={subHeaderStyle}>{subtitle}</Text.H3>}
          <Text.Large sx={descriptionStyle}>{description}</Text.Large>
          <Text.Large sx={contactInfoStyle}>
            For help, contact{' '}
            <Link to={`mailto:${SUPPORT_EMAIL}`}>
              <Text.Large as="span" color={Colors.TextLink}>
                {SUPPORT_EMAIL}
              </Text.Large>
            </Link>
          </Text.Large>
          <Button
            onClick={handleBackClick}
            startAdornment={<Icon name={Icon.Name.ChevronLeft} />}
            sx={backButtonStyle}
          >
            Go back
          </Button>
        </FlexColumn>
      </Box>
    </Box>
  );
};

export default ErrorCover;
